<template>
  <div class="assignMain">
    <div class="displayMain"> 
      <div class="headerMain"> 
        <div class="headerTitle"> {{title}} </div> 
      </div>

      <div class="contentMain"> 
        <div class="topSection"> 
          <div class="leftCol"> 
            <div class="assignDetailMain"> 
              <div class="assignDetailTitle"> Consignment No </div>
              <div class="assignDetailValue"> {{assignRFC['ConsignmentNo']}} {{assignRFC['Consignment #']}} </div> 
            </div>  
            <div class="assignDetailMain">
              <div class="assignDetailTitle">Container No </div>
              <div class="assignDetailValue"> {{assignRFC['ContainerNo']}} {{assignRFC['Container #']}} </div>
            </div>  
            <div class="assignDetailMain">
              <div class="assignDetailTitle">SzTyp / Hdg / Del </div>
              <div class="assignDetailValue"> 
                {{!assignRFC['Cont Size'] ? '' : assignRFC['Cont Size'] + (!assignRFC['Cont Type'] ? '' : assignRFC['Cont Type']) + ' / '}}
                {{!assignRFC['Sz/Ty'] ? '' : assignRFC['Sz/Ty'] + ' / '}}
                {{!assignRFC['Handling Type'] ? '' : assignRFC['Handling Type'] + ' / '}}
                {{!assignRFC['Delivery Type'] ? '' : assignRFC['Delivery Type']}}
                {{!assignRFC['Hdg'] ? '' : assignRFC['Hdg'] + ' / '}}
                {{!assignRFC['Del'] ? '' : assignRFC['Del']}}
              </div>
            </div>  
          </div>
          <div class="leftCol"> 
            <Input class="assignInput" placeholder="Seal No" :inputValue.sync="assignSealNo"/>
            <Remarks class="assignInput" placeholder="Seal No" :text.sync="assignRemarks"/>
          </div>
        </div>
        <div class="bottomSection"> 
          
          <div class="validatorMain">
            <div class="validatorHeader"> Assign Prime Mover </div>
            <Dropdown class="assignInput" placeholder="Prime Mover" :items.sync="assignPersistentData['assignPM']" itemKey="desc"
              :selectedObject.sync="selectedPM" @selected="assignSelected" :isRequired="true" :errorMessage="assignErrors['PM']"/>
            <div class="validatorContent"> 
              <Validator title="Available" :value="!selectedPM ? '' : (selectedPM['Availability'] == '1' ? 'Yes' : 'No')" 
                :valid="!selectedPM ? false : (selectedPM['Availability'] == '1' ? true : false)" />
              <Validator title="Road Tax" :value="!selectedPM ? '' : selectedPM['RoadTaxExpiryDate']" 
               :valid="!selectedPM ? false : checkExpired(selectedPM['RoadTaxExpiryDate'])"/>
              <Validator title="Inspection" :value="!selectedPM ? '' : selectedPM['InspectionDate']" 
               :valid="!selectedPM ? false : checkExpired(selectedPM['InspectionDate'])"/>
              <Validator title="Permit" :value="!selectedPM ? '' : selectedPM['PermitExpiryDate']" 
               :valid="!selectedPM ? false : checkExpired(selectedPM['PermitExpiryDate'])"/>
            </div>
            <Dropdown class="assignInput" placeholder="Trailer No" :items.sync="assignPersistentData['assignTR']" itemKey="desc"
              :selectedObject.sync="selectedTrailer" @selected="assignSelected"/>
          </div>

          <div class="validatorMain">
            <div class="validatorHeader"> Assign Driver </div>
            <Dropdown class="assignInput" placeholder="Driver" :items.sync="assignPersistentData['assignDriver']" itemKey="desc"
              :selectedObject.sync="selectedDriver" @selected="assignSelected" :isRequired="true" :errorMessage="assignErrors['Driver']"/>
            <div class="validatorContent">
              <Validator title="Driver License" :value="!selectedDriver ? '' : selectedDriver['DrvLicenseExpiryDate']" 
               :valid="!selectedDriver ? false : checkExpired(selectedDriver['DrvLicenseExpiryDate'])"/>
              <Validator title="Badge License" :value="!selectedDriver ? '' : selectedDriver['BadgeLicenseExpiryDate']" 
               :valid="!selectedDriver ? false : checkExpired(selectedDriver['BadgeLicenseExpiryDate'])"/>
              <Validator title="Port Pass" :value="!selectedDriver ? '' : selectedDriver['PortPassExpiryDate']" 
               :valid="!selectedDriver ? false : checkExpired(selectedDriver['PortPassExpiryDate'])"/>
            </div>
          </div>

          <div class="validatorMain">
            <div class="validatorHeader"> Assign Movement </div>
            <Dropdown class="assignInput" placeholder="Movement" :items.sync="assignPersistentData['assignMovement']" itemKey="desc"
              :selectedObject.sync="selectedMovement" @selected="assignSelected" :isRequired="true" :errorMessage="assignErrors['Movement']"/>
            <Dropdown class="assignInput" placeholder="From" :items="assignPersistentData['assignFromTo']" itemKey="desc"
              :selectedObject.sync="selectedFrom" @selected="assignSelected" :isRequired="true" :errorMessage="assignErrors['From']"/>
            <Dropdown class="assignInput" placeholder="To" :items="assignPersistentData['assignFromTo']" itemKey="desc"
              :selectedObject.sync="selectedTo" @selected="assignSelected" :isRequired="true" :errorMessage="assignErrors['To']"/>
            <DateTime class="assignInput" title="ETD" :value.sync="assignETD"/> 
            <DateTime class="assignInput" title="ETA" :value.sync="assignETA"/>
          </div>

        </div>
      </div>

      <div class="footerMain">
        <div class="footerMsgBox" :style="{ 'background-color' : errorColor }"> {{errorMsg}} </div>
        <button class="footerButton" @click="assignBtn('close')">Close</button>
        <button class="footerButton" @click="assignBtn('save')" :disabled="assignSaveDisabled">Save</button>
      </div>

      <div class="loaderMain" v-if="loadMsg">
        <div class="loaderMsg"> {{loadMsg}} </div>
      </div>

    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import Remarks from '@/components/RemarksBox.vue';
  import Validator from '@/components/VehicleTracker/ValidatorV2.vue';
  
  export default {
    name: 'assign',
    components: {
      Input, InputQuery, DateTime, Dropdown, Remarks, Validator,
    },
    props: {
      title: { type: String, default: 'Title' },
      errorMsg: { type: String, default: '' }, 
      errorColor: { type: String, default: '' }, //#ff79794a - error #fff6794a - regular
      
      //-------- Public
      assignRFC: { type: Object, default: function() { return {}; }},
      assignRFCRaw: { type: Object, default: function() { return {}; }},
      assignVehicles: { type: Array, default: function() { return []; }},

      //-------- Assign Props
      assignLoaded: { type: Boolean, default: false },
      assignPersistentData: { type: Object, default: function() { return {}; }},
      selectedPM: { type: Object, default: function() { return null; }},
      selectedTrailer: { type: Object, default: function() { return null; }},
      selectedDriver: { type: Object, default: function() { return null; }},
      selectedMovement: { type: Object, default: function() { return null; }},
      selectedFrom: { type: Object, default: function() { return null; }},
      selectedTo: { type: Object, default: function() { return null; }},

      assignSealNo: { type: String, default: '' },
      assignRemarks: { type: String, default: '' },
      assignETD: { type: Date, default: function() { return new Date; }},
      assignETA: { type: Date, default: function() { return new Date; }},
      testArray: { type: Array, default: function() { return []; }},

      assignErrors: { type: Object, default: function() { return {
        'PM' : '',
        'Driver' : '',
        'Movement' : '',
        'From' : '',
        'To' : '',
      }; }},
      assignSaveDisabled: { type: Boolean, default: false },

      //-------- Loader Props
      loadMsg: { type: String, default: 'Loading' },
    },
    mounted() {
      this.assignSealNo = !this.assignRFC['Seal No'] ? '' : this.assignRFC['Seal No']
      this.assignRemarks = !this.assignRFC['Remarks'] ? '' : this.assignRFC['Remarks']
      this.getData();
      //this.testData();
    },
    methods: {
      testFnc: function () {
        console.log(this.assignPersistentData['assignPM']);
        console.log(this.selectedPM);
      },
      testData: function() {
        this.assignRFC = {
          "Advice For RFC": "2010-04-07 00:00",
          "Area": "SUBANG JAYA",
          "Company": "RAHMAT AZIM BIN ABDUL AZIZ",
          "ConsignmentNo": "HE0000102-002",
          "Cont Size": "20",
          "Cont Type": "GP",
          "ContainerNo": "TEST1001001",
          "Delivery Time": "2010-03-16 17:20",
          "Delivery Trailer": "TRX",
          "Delivery Type": "SL",
          "Departure Code": "JMY1",
          "Destination Code": "RAHMAT",
          "Drop Off": "KCT",
          "ETA": "2007-02-28 00:00",
          "Handling Type": "N",
          "Latitude": "3.0171",
          "Longitude": "101.5778",
          "RFC Remarks": "[F-002]",
          "Remarks": "UPGRADED,CLEAN & GOOD CONDITION CONTR",
          "Seal No": "SEAL1001001",
          "To Collect": "2010-03-18 00:00",
        };
        this.assignVehicles = [
          {
            "Dep Code": "JMY2",
            "Dep Company": "JAMBATAN MERAH YARD 2",
            "Dep Company Code": "JMY2",
            "Dep Latitude": "",
            "Dep Longitude": "",
            "Dest Code": "AAIE",
            "Dest Company": "AUTO AIR INDUSTRIES S/B",
            "Dest Company Code": "AAIE",
            "Dest Latitude": "0",
            "Dest Longitude": "0",
            "Driver Code": "039",
            "Driver Name": "ROSLI BIN YUSSOFF",
            "ETA": "2020-12-15 11:46",
            "GPS Log Time": "2020-06-19 15:57",
            "Job No": "HE0000015-01",
            "Latitude": "3.085548",
            "Longitude": "101.459443",
            "Status": "",
            "Vehicle No": "KCH1355 (EH534)",
          },
          {
            "Dep Code": "TCW",
            "Dep Company": "ASIATIC CONTAINER SERVICES SDN BHD",
            "Dep Company Code": "TCW",
            "Dep Latitude": "3.03321",
            "Dep Longitude": "101.37038",
            "Dest Code": "AAE01",
            "Dest Company": "AAE01 TSETING",
            "Dest Company Code": "AAE01",
            "Dest Latitude": "",
            "Dest Longitude": "",
            "Driver Code": "039",
            "Driver Name": "ROSLI BIN YUSSOFF",
            "ETA": "2020-12-17 14:44",
            "GPS Log Time": "2020-12-21 16:26",
            "Job No": "HE0000028-01",
            "Latitude": "3.0159",
            "Longitude": "101.3693",
            "Status": "",
            "Vehicle No": "VAL8255 (EH518)",
          },
        ];
      },
      getData: async function() {
        console.log('Getting Data');
        this.assignLoaded = false;

        //-------- Prime Movers
        try {
          this.loadMsg = 'Getting Prime Movers'
          var assignPM = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=PM&available=1`);
          //console.log(assignPM);
          var assignPMF = [];
          if (Array.isArray(assignPM)) {
            assignPM.forEach((pm) => {
              assignPMF.push({
                'type': 'PM',
                'VehicleNo': !pm['VehicleNo'] ? '' : pm['VehicleNo'].trim(),
                'VehicleCode': !pm['VehicleCode'] ? '' : pm['VehicleCode'].trim(),
                'Availability': !pm['Availability'] ? '' : pm['Availability'].trim(),
                'RoadTaxExpiryDate': !pm['RoadTaxExpiryDate'] ? '' : this.formatDatetoString(pm['RoadTaxExpiryDate'].trim()),
                'InspectionDate': !pm['InspectionDate'] ? '' : this.formatDatetoString(pm['InspectionDate'].trim()),
                'PermitExpiryDate': !pm['PermitExpiryDate'] ? '' : this.formatDatetoString(pm['PermitExpiryDate'].trim()),
                'desc': !pm['VehicleNo'] ? '' : pm['VehicleNo'].trim() + (!pm['VehicleCode'] ? '' : (' (' + pm['VehicleCode'].trim() + ')')),
              });
            });
          } else { console.log(assignPM) }
          this.$set(this.assignPersistentData, 'assignPM', assignPMF);
          this.$set(this.assignPersistentData, 'assignPMRaw', assignPM);
        } catch (e) { console.log(e); }

        //-------- Trailer
        try {
          this.loadMsg = 'Getting Trailers'
          var assignTR = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=TR&available=1`);
          console.log(assignTR);
          var assignTRF = [];
          if (Array.isArray(assignTR)) {
            assignTR.forEach((tr) => {
              assignTRF.push({
                'type': 'TR',
                'VehicleNo': !tr['VehicleNo'] ? '' : tr['VehicleNo'].trim(),
                'VehicleCode': !tr['VehicleCode'] ? '' : tr['VehicleCode'].trim(),
                'VehicleLength': !tr['VehicleLength'] ? '' : tr['VehicleLength'],
                'Availability': !tr['Availability'] ? '' : tr['Availability'].trim(),
                'SideLoader': !tr['SideLoader'] ? '' : tr['SideLoader'].trim(),
                'RoadTaxExpiryDate': !tr['RoadTaxExpiryDate'] ? '' : this.formatDatetoString(tr['RoadTaxExpiryDate'].trim()),
                'InspectionDate': !tr['InspectionDate'] ? '' : this.formatDatetoString(tr['InspectionDate'].trim()),
                'PermitExpiryDate': !tr['PermitExpiryDate'] ? '' : this.formatDatetoString(tr['PermitExpiryDate'].trim()),
                'desc': !tr['VehicleNo'] ? '' : tr['VehicleNo'].trim() + (!tr['VehicleCode'] ? '' : (' (' + tr['VehicleCode'].trim() + ')')),
              });
            });
          } else { console.log(assignTR) }
          this.$set(this.assignPersistentData, 'assignTR', assignTRF);
          this.$set(this.assignPersistentData, 'assignTRRaw', assignTR);
          var assignTrailer = this.assignPersistentData['assignTR'].filter((tr) => { return tr['VehicleNo'] == this.assignRFC['Delivery Trailer'].trim()});
          if (assignTrailer.length > 0) { this.selectedTrailer = assignTrailer[0] }
        } catch (e) { /*console.log(e);*/ }

        //-------- Driver
        try {
          this.loadMsg = 'Getting Drivers'
          var assignDriver = await this.$apiCallV2(`/VehicleTracker/GetEmployeeListByDepartment`);
          //console.log(assignDriver['data']);
          var assignDriverF = [];
          if (Array.isArray(assignDriver)) {
            assignDriver.forEach((d) => {
              assignDriverF.push({
                'type' : 'D',
                'Staff No': !d['Staff_No'] ? '' : d['Staff_No'].trim(),
                'Staff Name': !d['Staff_Name'] ? '' : d['Staff_Name'].trim(),
                'DrvLicenseExpiryDate': !d['DrvLicenseExpiryDate'] ? '' : this.formatDatetoString(d['DrvLicenseExpiryDate'].trim()),
                'BadgeLicenseExpiryDate': !d['BadgeLicenseExpiryDate'] ? '' : this.formatDatetoString(d['BadgeLicenseExpiryDate'].trim()),
                'PortPassExpiryDate': !d['PortPassExpiryDate'] ? '' : this.formatDatetoString(d['PortPassExpiryDate'].trim()),
                'desc': !d['Staff_Name'] ? '' : d['Staff_Name'].trim() + (!d['Staff_No'] ? '' : (' (' + d['Staff_No'].trim() + ')')),
              });
            });
          }
          this.$set(this.assignPersistentData, 'assignDriver', assignDriverF);
          this.$set(this.assignPersistentData, 'assignDriverRaw', assignDriver);
        } catch (e) { console.log(e); }

        //-------- Movement
        try {
          this.loadMsg = 'Getting Movements'
          var assignMovement = await this.$apiCallV2(`/VehicleTracker/GetMovementType?cnno=` + (!this.assignRFC['ConsignmentNo'] ? this.assignRFC['Consignment #'] : this.assignRFC['ConsignmentNo']));
          //console.log(assignMovement['data']);
          var assignMovementF = [];
          if (Array.isArray(assignMovement)) {
            assignMovement.forEach((m) => {
              assignMovementF.push({
                'type' : 'M',
                'MovementType': !m['MovementType'] ? '' : m['MovementType'].trim(),
                'MovementTypeDesc': !m['MovementTypeDesc'] ? '' : m['MovementTypeDesc'].trim(),
                'desc': !m['MovementTypeDesc'] ? '' : m['MovementTypeDesc'].trim() + (!m['MovementType'] ? '' : (' (' + m['MovementType'].trim() + ')')),
              });
            });
          }
          this.$set(this.assignPersistentData, 'assignMovement', assignMovementF);
          this.$set(this.assignPersistentData, 'assignMovementRaw', assignMovement);
          this.selectedMovement = this.assignPersistentData['assignMovement'].filter((m) => { return m['MovementType'] == 'C1W' })[0];
        } catch (e) { console.log(e); }


        //-------- From / To
        try {
          this.loadMsg = 'Getting Destination Items'
          var fromto = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=destination&module=FMS`);
          //console.log(fromto);
          var fromtoF = [];
          if (Array.isArray(fromto)) {
            fromto.forEach((ft) => {
              fromtoF.push({
                'type': 'FT',
                'Dest Code': !ft['Destination Code'] ? '' : ft['Destination Code'].trim(),
                'Area Code': !ft['Area Code'] ? '' : ft['Area Code'].trim(),
                'Area Name': !ft['Area Name'] ? '' : ft['Area Name'].trim(),
                'Address': !ft['Address'] ? '' : ft['Address'].trim(),
                'Post Code': !ft['PostCode'] ? '' : ft['PostCode'].trim(),
                'City': !ft['City'] ? '' : ft['City'].trim(),
                'Company': !ft['Company'] ? '' : ft['Company'].trim(),
                'Latitude': !ft['Latitude'] ? '' : ft['Latitude'].trim(),
                'Longitude': !ft['Longitude'] ? '' : ft['Longitude'].trim(),
                'desc': !ft['Destination Code'] ? '' : ft['Destination Code'].trim() + (!ft['City'] ? '' : (' (' + ft['City'].trim() + ')')),
              });
            });
          } else { console.log(fromtoF) }
          this.$set(this.assignPersistentData, 'assignFromTo', fromtoF);
          this.$set(this.assignPersistentData, 'assignFromToRaw', fromto);
          var assignFrom = this.assignPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.assignRFC['Departure Code'] });
          if (assignFrom.length > 0) { this.selectedFrom = assignFrom[0] }
          var assignTo = this.assignPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.assignRFC['Destination Code'] });
          if (assignTo.length > 0) { this.selectedTo = assignTo[0] }
        } catch (e) { console.log(e); }

        this.loadMsg = ''
        this.assignLoaded = true;
      },
      assignSelected: function(data) {
        switch (data['type']) {
          case 'PM':
            console.log(this.selectedPM);
            this.assignErrors['PM'] = '';
            if (this.assignVehicles.length > 0 && !this.selectedDriver) {
              var assignPM = this.assignVehicles.filter((v) => { return v['Vehicle No'].split(" ")[0].trim() == data['VehicleNo'] });
              if (assignPM.length > 0) { 
                var assignDriver = this.assignPersistentData['assignDriver'].filter((d) => { return d['Staff No'].trim() == assignPM[0]['Driver Code'].trim()});
                if (assignDriver.length > 0) { 
                  this.selectedDriver = assignDriver[0];
                  this.assignErrors['Driver'] = '';
                  this.errorMsg = 'Driver field has been autofilled';
                }
              } else { this.errorMsg = ''; }
            } else { this.errorMsg = ''; }
            break;
          case 'TR':
            console.log(this.selectedTrailer);
            break;
          case 'D':
            this.assignErrors['Driver'] = '';
            console.log(this.selectedDriver);
            if (this.assignVehicles.length > 0) {
              var assignDriver = this.assignVehicles.filter((v) => { return v['Driver Code'].trim() == data['Staff No'] });
              //console.log(assignDriver);
              if (assignDriver.length > 0 && !this.selectedPM) { 
                var assignPM = this.assignPersistentData['assignPM'].filter((pm) => { return pm['VehicleNo'].trim() == assignDriver[0]['Vehicle No'].split(" ")[0].trim()});
                console.log(assignPM);
                if (assignPM.length > 0) {
                  this.selectedPM = assignPM[0]; 
                  this.assignErrors['PM'] = '';
                  this.errorMsg = 'Prime Mover field has been autofilled';
                } else { this.errorMsg = ''; }
              } else { this.errorMsg = ''; }
            }
            break;
          case 'M':
            this.assignErrors['Movement'] = '';
            console.log(this.selectedMovement);
            break;
          case 'FT':
            this.assignErrors['From'] = '';
            this.assignErrors['To'] = '';
            break;
        }
      },
      assignBtn: async function(btn) {
        switch (btn) {
          case 'close':
            //console.log('close clicked');
            console.log(this.assignRFCRaw);
            this.assignSaveDisabled = false;
            this.$emit('assignClose');
            break;
          case 'save':
            console.log('save clicked');
            this.$emit('assignSave');

            //---- Check for missing fields
            this.assignErrors['PM'] = this.selectedPM ? '' : 'Prime Mover required';
            this.assignErrors['Driver'] = this.selectedDriver ? '' : 'Driver required';
            this.assignErrors['Movement'] = this.selectedMovement ? '' : 'Movement required';
            this.assignErrors['From'] = this.selectedFrom ? '' : 'Departure required';
            this.assignErrors['To'] = this.selectedTo ? '' : 'Destination required';

            //---- Return error message if error exist
            var errorFlag = false;
            Object.keys(this.assignErrors).forEach((e) => { if (this.assignErrors[e]) { errorFlag = true; } })
            if (errorFlag) { 
              this.errorMsg = 'Please ensure all required fields are not empty';
              this.errorColor = '#ff79794a';
            } else { 
              this.errorMsg = 'Saving...';
              this.errorColor = '#fff6794a';

              try {
                var assignData = {
                  'VehicleCode' : !this.selectedPM['VehicleCode'] ? '' : this.selectedPM['VehicleCode'].trim(),
                  'Staff_No' : !this.selectedDriver['Staff No'] ? '' : this.selectedDriver['Staff No'].trim(),
                  'MovementType' : !this.selectedMovement['MovementType'] ? '' : this.selectedMovement['MovementType'].trim(),
                  'JIDate' : !this.assignETD ? '' : this.formatDatetoString(this.assignETD).split(' ')[0],
                  'CN' : !this.assignRFC['ConsignmentNo'] ? this.assignRFC['Consignment #'] : this.assignRFC['ConsignmentNo'].trim(),
                  'B2BCN' : !this.assignRFC['B2BConsignmentNo'] ? '' : this.assignRFC['B2BConsignmentNo'].trim(),
                  'SealNo' : !this.assignSealNo ? '' : this.assignSealNo.trim(),
                  'DepartureCode' : !this.selectedFrom ? '' : this.selectedFrom['Dest Code'].trim(),
                  'DestinationCode' : !this.selectedTo ? '' : this.selectedTo['Dest Code'].trim(),
                  'EstDepartTime' : !this.assignETD ? '' : this.formatDatetoString(this.assignETD) + ':00',
                  'EstArriveTime' : !this.assignETA ? '' : this.formatDatetoString(this.assignETA) + ':00',
                  'TrCode' : !this.selectedTrailer ? '' : this.selectedTrailer['VehicleCode'].trim(),
                  'Remarks' : !this.assignRemarks ? '' : this.assignRemarks.trim(),
                  'UserID' : !this.assignRFCRaw['UserID'] ? '' : this.assignRFCRaw['UserID'].trim(),
                  'DateUpdated' : !this.assignRFCRaw['DateUpdated'] ? '' : this.formatDatetoString(this.assignRFCRaw['DateUpdated'].trim()),
                  'DeviceID' : '',
                  'MobileNo' : '',
                  'GPSLatitude' : !this.assignRFC['Latitude'] ? '' : this.assignRFC['Latitude'].trim(),
                  'GPSLongitude' : !this.assignRFC['Longitude'] ? '' : this.assignRFC['Longitude'].trim(),
                };
                console.log(assignData);
                var assignR = await this.$apiCallV2(`/VehicleTracker/HMSAssignTrip`, assignData);
                console.log(assignR);
                if (Array.isArray(assignR)) { 
                  if (assignR[0]['Results'] > 0) {
                    this.errorMsg = assignR[0]['ErrMsg']; 
                    this.errorColor = '#ff79794a';
                  } else {
                    this.assignSaveDisabled = true;
                    this.errorMsg = 'Assignment successful. Close to continue...'; 
                    this.errorColor = '#00ff004a';
                  }
                } else {
                  this.errorMsg = assignR; 
                  this.errorColor = '#ff79794a';
                }
              } catch(e) { console.log(e); }
            }

            
            break;
        }
      },
      assignInputClick: async function(input) {
        console.log(input);
      },
      //-------- Utility Methods
      formatDatetoString: function (date) {
        if (typeof date == 'string') {
          var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '');
          try {
            var dateFF = new Date(dateF);
            if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
          } catch (e) { /*console.log(e);*/ }
        } else {
          var dateFF = date;
        }
      
        var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
        var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
        var y = dateFF.getFullYear();
        var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
        var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

        return `${y}-${m}-${d} ${hh}:${mm}`;
      },
      formatStringtoDate: function (date) {
        var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
        var dateFF = dateF.split('/');
        return new Date(dateFF[0]);
      },
      checkExpired: function (date) {
        return (!date ? false : (this.formatStringtoDate(date) >= Date.now()))
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .assignMain {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }

  .displayMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .headerMain {
    width: 100%;
    height: 30px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #0003;
  }

  .headerTitle {
    width: 100%;
    height: 100%;
    padding: 0 4px;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
  }
  
  .contentMain {
    width: 100%;
    height: auto;
    padding: 4px; 
    position: absolute;
    top: 30px;
    bottom: 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .footerMain {
    width: 100%;
    height: 40px;
    padding: 0 4px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footerMsgBox {
    width: auto;
    height: 100%;
    flex: 1;
    padding: 0 4px;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    overflow: hidden;
    background-color: #fff6794A;
    border: solid 1px #0004;
    border-radius: 0 0 0 4px;
  }

  .footerButton {
    width: 60px;
    height: 100%;
    margin: 0 0 0 4px;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .topSection {
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .leftCol {
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .rightCol {
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .bottomSection {
    width: 100%;
    height: auto;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-y: scroll;
    overflow-x: hidden;
    white-space: pre-wrap;
  }

  .assignInput {
    width: 100%;
    font-size: 12px;
    white-space: normal;
  }

  .assignDetailMain {
    width: 100%;
    height: auto;
    margin: 0 0 2px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .assignDetailTitle {
    width: 130px;
    font-size: 12px;
    font-weight: bold;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
  }

  .assignDetailValue {
    width: auto;
    height: 100%;
    flex: 1;
    padding: 0 4px 0 8px;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    white-space: nowrap;
  }

  /* -- Validator CSS -- */
  .validatorMain {
    width: 33%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .validatorHeader {
    width: 100%;
    height: 24px;
    min-height: 24px;
    padding: 0 4px;
    margin: 0 0 2px 0;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #0003;
    user-select: none;
  }

  .validatorContent {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  /* -- Loader CSS -- */
  .loaderMain {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 255;
  }

  .loaderMsg {
    width: auto;
    height: 30px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    box-shadow: 0 0 8px #0008;
    border-radius: 4px;
    user-select: none;
  }

</style>
